import ContactsSettings from '@onereach/sdk/dist/contacts_settings_api';
import Agents from '@onereach/sdk/dist/hitl_settings_api';
import Files from '@onereach/sdk/dist/files';
import Users from '@onereach/sdk/dist/users';
import { Users as MultiUsers } from '@or-sdk/users';
import { Contacts } from '@or-sdk/contacts';
import { Files as Media } from '@or-sdk/files';
import { Deployments } from '@or-sdk/deployments';

export class HttpSDK {
  /** Only some agents-related endpoints are used here */
  public static agents: Agents;
  public static users: Users;
  public static contactsSettings: ContactsSettings;
  public static files: Files;
  /* TODO: We can remove unused SDKs */
  public static multiusers: MultiUsers;
  public static contacts: Contacts;
  public static media: Media;
  public static deployments: Deployments;

  public static initialize(args: {
    token: () => string;
    providersAccountId: string;
    httpGatewayURL: string;
    serviceDiscoveryURL: string;
    sdkURL: string;
    usersURL: string;
    contactsURL: string;
    filesURL: string;
    /** Media is a new Files API that uses EKS API */
    mediaURL: string;
    dataHubURL: string;
  }) {
    const {
      token,
      providersAccountId,
      httpGatewayURL,
      serviceDiscoveryURL,
      sdkURL,
      usersURL,
      contactsURL,
      filesURL,
      mediaURL,
      dataHubURL,
    } = args;

    const config = {
      httpGatewayUrl: httpGatewayURL,
      sdkApiUrl: sdkURL,
      providersAccountId,
      userTokenFactory: () => `USER ${token()}`,
    };

    this.agents = new Agents(config);
    this.users = new Users(config);
    this.contactsSettings = new ContactsSettings(config);
    this.files = new Files({ ...config, filesApiUrl: filesURL });

    this.multiusers = new MultiUsers({
      token: () => `USER ${token()}`,
      usersUrl: usersURL,
      sdkUrl: sdkURL,
      discoveryUrl: serviceDiscoveryURL,
    });

    this.contacts = new Contacts({
      token: () => `USER ${token()}`,
      contactsApiUrl: contactsURL,
      discoveryUrl: serviceDiscoveryURL,
    });

    this.media = new Media({
      token: () => `USER ${token()}`,
      filesApiUrl: mediaURL,
    });

    this.deployments = new Deployments({
      token: () => `USER ${token()}`,
      dataHubSvcUrl: dataHubURL,
      discoveryUrl: serviceDiscoveryURL,
    });
  }
}
